import { patientI } from './patient';
import { practitionerI } from './practitioner';
import { procedureI } from './procedure';
import { organizationI } from './organization';
import { patientsMock } from '../data/mock.json';

export type encounterType = 'Exame' | 'Consulta';

export interface Encounter {
  encounter_id?: string;
  name: string;
  value?: string;
  paymentMethod?: string;
  value_agreement?: string;
  type: string;
  active: boolean;
  status: string;
  specialty?: string;
  specialty_code: string;
  servicetype_name?: string;
  appointment: string;
  servicecategory_name?: string;
  organization: {
    name: string;
    organization_id: string;
  };
  secretary?: {
    name: string;
    secretary_id: string;
  };
  practitioner: {
    name: string;
    practitioner_id: string;
  };
  patient: {
    name: string;
    patient_id: string;
    birthDate?: string;
    cpf?: string;
    phone?: string;
  };
  status_payment?: string;
  confirmed_by?: string;
  payment_at?: string;
  startDate: string;
  endDate?: string;
  diagnosis?: string;
  byOrderInfo?: {
    isByOrder?: boolean;
    startServiceHour?: string;
  };
  scheduling_method?: string;
  health_plan?: any;
  agreement_approved?: boolean;
  content?: any[];
  patient_details?: any;
  modifiedBy?: any;
  cancelledReason?: string;
  attendance_code_verified?: boolean;
  created_at?: string;
  updated_at?: string;
}

interface Coding {
  code: string;
  display: string;
}

interface Service {
  coding: Coding[];
}

interface Subject {
  reference: string;
  code: string;
  display: string;
}

interface Participant {
  reference: string;
  code: string;
  display: string;
}

interface ServiceProvider {
  reference: string;
  code: string;
  display: string;
}

export interface EncounterAPIResponse {
  encounter_id?: string;
  name: string;
  value?: string;
  paymentMethod?: string;
  value_agreement?: string;
  active: boolean;
  type: string;
  status: string;
  appointment: string;
  diagnosis: string;
  serviceCategory: Service[];
  serviceType: Service[];
  specialty: Service[];
  subject: Subject;
  participant: Participant[];
  serviceProvider: ServiceProvider;
  plannedStartDate: string;
  plannedEndDate: string;
  status_payment?: string;
  payment_at?: string;
  confirmed_by?: string;
  byOrderInfo?: {
    isByOrder?: boolean;
    startServiceHour?: string;
  };
  scheduling_method?: string;
  health_plan?: any;
  agreement_approved?: boolean;
  content?: any[];
  patient_details?: any;
  modifiedBy?: any;
  cancelledReason?: string;
  attendance_code_verified?: boolean;
  created_at?: string;
  updated_at?: string;
}

/**  tipagens antigas */
export interface encounterI {
  id: number | null;
  name: string;
  subject: patientI;
  participant?: practitionerI;
  status: string;
  serviceProvider?: organizationI;
  active: boolean;
  appointment?: string;
  type: encounterType;
  plannedStartDate?: string;
  plannedEndDate?: string;
  procedure?: procedureI;
  diagnosis?: string;
}

export interface encounterFHIR {
  encounter_id: number | null;
  name: string;
  value?: string;
  paymentMethod?: string;
  type: string;
  status: string;
  specialty?: string;
  servicetype_name?: string;
  servicecategory_name?: string;
  organization: {
    name: string;
    organization_id: string;
  };
  practitioner: {
    name: string;
    practitioner_id: string;
  };
  patient: {
    name: string;
    patient_id: string;
    birthDate?: string;
    cpf?: string;
    phone?: string;
  };
  plannedStartDate?: string;
  plannedEndDate?: string;
  status_payment?: string;
  confirmed_at?: string;
  diagnosis?: string;
  byOrderInfo?: {
    isByOrder?: boolean;
    startServiceHour?: string;
  };
  scheduling_method?: string;
  health_plan?: any;
  modifiedBy?: any;
}

export interface scheduleFHIR {
  encounter_id: number | null;
  name: string;
  type: string;
  status: string;
  specialty?: string;
  servicetype_name?: string;
  servicecategory_name?: string;
  organization: {
    name: string;
    organization_id: string;
  };
  practitioner: {
    name: string;
    practitioner_id: string;
  };
  patient: {
    name: string;
    patient_id: string;
    birthDate?: string;
    cpf?: string;
    phone?: string;
  };
  plannedStartDate?: string;
  plannedEndDate?: string;
  diagnosis?: string;
  scheduling_method?: string;
  health_plan?: any;
}

export interface EncounterListAPIResponse {
  Count: number;
  Items: EncounterAPIResponse[];
  LastEvaluatedKey: string | null;
}

export interface EncounterListResult {
  count: number;
  items: Encounter[];
  lastEvaluatedKey: string | null;
}

export const encounterInitialState: encounterI = {
  id: null,
  name: '',
  subject: patientsMock[1],
  status: 'planned',
  type: 'Exame',
  active: true,
};

export interface encounterStatus {
  id: string;
  text: string;
  color: string;
  icon: string;
}

export const encounterKeys = Object.keys(encounterInitialState);
